import { useTheme } from '@mui/material';
import React, { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {}

const TableViewIcon: React.FC<Props> = ({ width = 20, height = 14, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="12"
        rx="1"
        stroke={theme.palette.text.primary}
        strokeWidth="2"
      />
      <rect x="6" y="2" width="2" height="10" fill="#171717" />
      <rect x="12" y="2" width="2" height="10" fill="#171717" />
      <rect x="2" y="6" width="16" height="2" fill="#171717" />
    </svg>
  );
};

export default TableViewIcon;
